import { ExclamationCircleOutlined } from "@ant-design/icons";

export const configModal = {
	icon: <ExclamationCircleOutlined />,
	okText: "Sim",
	zIndex: 10000,
	okType: "primary",
	cancelText: "Não",
	okButtonProps: {
		className: "ant-btn-modal",
	},
};
